"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateSysName = function validateSysName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('business.error.sysName')));
      } else if (_this.errorKeys.indexOf('sysName') >= 0) {
        callback(new Error(_this.errorInfo['sysName']));
        _this.resetError('sysName');
      } else {
        callback();
      }
    };
    var validateIndexUrl = function validateIndexUrl(rule, value, callback) {
      if ((0, _validate.validRule2)(value)) {
        callback(new Error(_this.$t('business.error.indexUrl')));
      } else if (_this.errorKeys.indexOf('indexUrl') >= 0) {
        callback(new Error(_this.errorInfo['indexUrl']));
        _this.resetError('indexUrl');
      } else {
        callback();
      }
    };
    return {
      pageName: 'business',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogStatus: 'create',
      form: {
        systemPk: '',
        sysName: '',
        indexUrl: '',
        remark: ''
      },
      initForm: {
        systemPk: '',
        sysName: '',
        indexUrl: '',
        remark: ''
      },
      rules: {
        sysName: [{
          required: true,
          trigger: ['change'],
          validator: validateSysName
        }],
        indexUrl: [{
          required: true,
          trigger: ['change'],
          validator: validateIndexUrl
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit
      };
      this.listLoading = true;
      this.$api.business.getBusinessList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        systemPk: '',
        sysName: '',
        indexUrl: '',
        remark: ''
      };
      this.initForm = {
        systemPk: '',
        sysName: '',
        indexUrl: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.systemPk;
      this.isShowModel = true;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.business.getBusinessDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            systemPk = _res$data.systemPk,
            sysName = _res$data.sysName,
            indexUrl = _res$data.indexUrl,
            remark = _res$data.remark;
          _this5.form = {
            systemPk: systemPk,
            sysName: sysName,
            indexUrl: indexUrl,
            remark: remark
          };
          _this5.initForm = {
            systemPk: systemPk,
            sysName: sysName,
            indexUrl: indexUrl,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          _this5.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this6.isLoading = true;
        _this6.$api.business.deleteBusiness([row.systemPk]).then(function (res) {
          _this6.isLoading = false;
          _this6.refreshData();
        }).catch(function () {
          _this6.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this7 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this7.isLoading = true;
        _this7.$api.business.saveBusiness(_this7.form).then(function (res) {
          _this7.isLoading = false;
          _this7.isShowModel = false;
          _this7.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this7.resetError();
            err.errorInfos.forEach(function (item) {
              _this7.errorKeys.push(item.key);
              _this7.errorInfo[item.key] = item.errMsg;
            });
            _this7.$refs['dataForm'].validate();
            setTimeout(function () {
              _this7.$refs['dataForm'].clearValidate();
            }, 1500);
          }
          _this7.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};